import { Component, OnInit } from '@angular/core';
import { PremiumDueHandler } from './premium-due.handler.';
import { NotificationService } from '../services/notifications.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';

@Component({
  selector: 'sym-premium-due',
  templateUrl: './premium-due.component.html',
  styleUrls: ['./premium-due.component.scss'],
})
export class PremiumDueComponent extends PremiumDueHandler implements OnInit {
  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, headerService, router, settingService, offlineService);
  }
  ngOnInit() {}
}
